/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from "react";
import * as API from "../../framework/API/api";
import { getter } from "@progress/kendo-data-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "../../locale/useTranslation";
import { ApplicationConfigurationKeys, ENTITYNAME, LOGEVENT, MEDIATYPEENUM, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import { utility } from "../../framework/utility/utilityProvider";
import { getSelectedState } from "@progress/kendo-react-data-tools";
import { EditPageHeader } from "../../components/EditPageHeader";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { ScheduleAutoFillFuncListColumns } from "../../framework/utility/customColumns";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";


const DATA_ITEM_KEY = "index";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const AUTOFILL_SCHEDULE_CONF_FUNCS = {
    "ResetAutoFillPlaylistChildren": 1,
    "onReturnSlotDateTimeToPlannedNominalTime": 2,
    "fillUnderOverRunWithStiching": 3, //isKartoonChannel, isGodare, isSMG, isOutdoor, isEcity, isRock, isStarhub
    "ApplyBillBoards": 4, // variationRes
    "ApplyBreakBumpers": 5, // variationRes
    "ManageUnderAndOverRuns": 6, // header_ids, placeAllItemsInLast = false, pullVariations = true, variationData = undefined, checkBackToBackSameCategory = true, mediaTypeEnum = MEDIATYPEENUM.ANY
    "FillFormatSequenceInSchedule": 7, // variationRes, fetchMediaOldStyle, isSMG, keepFillingIfNoSpace
    "PlacingLastPositionItems": 8, //variationRes
    "saveCompleteScheduleChildrenandRefresh": 9,
    "ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly": 10, //variationRes, autoDeleteOffFooterOffset, realTimeSave = true, mediaTypeEnum = MEDIATYPEENUM.CLOSING
    "ReplaceItemsToMatchUnderAndOverRuns": 11, //variationRes, autoDeleteOffFooterOffset, realTimeSave = true, mediaTypeEnum = MEDIATYPEENUM.CLOSING
    "RefillAndDeleteUnderAndOverRun": 12, //variationRes, autoDeleteOffFooterOffset, fillInLastOnly = false, deleteFooter = true
    "FillFormatSequenceInScheduleBottomUpApproach": 13, // variationRes, fetchMediaOldStyle, isSMG, keepFillingIfNoSpace
    "PlaceRatingSlideAndRatingBug": 14,
    "MoveFirstSegmentBreakItemToLastSegment": 15,
    "PlaceSignOffIdOnLastSegment": 16,
    "PlacingFixedPositionItems": 17, //variationRes
    "PlacingFirstPositionItem": 18, //variationRes
    "MaximumDamageControl": 19, //maxDamageOffset,
    "PackPlaylistFor24Hours": 20 //variationRes
}

const AutoPlaylistConfiguration = (props) => {

    const { SID } = useParams();
    const loc = useLocation();
    const lang = useTranslation();
    const navigate = useNavigate();

    let blankDataItem = {
        SID: SID,
        Description: "",
        Channel: {},
        ExecutionSequence: [],
        Archive: false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channel, setChannel] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [selectedExecutionSequenceState, setSelectedExecutionSequenceState] = useState({});
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [selectedFunction, setSelectedFunction] = useState(null);
    const [parameterDataItem, setParameterDataItem] = useState({});

    //MAIN DATA GRID
    const [gridData, setGridData] = useState([]);

    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        loadCombo();
        if (SID > 0) {
            loadEditData();
        }
    }, []);

    const loadEditData = async () => {

        setLoadingStatus(lang.data_loading_error_message);

        let res = await API.getEntity(ENTITYNAME.AutoPlaylistConfiguration, parseInt(SID));

        if (res.success) {
            setDataItem({
                ...res.data,
                Description: loc?.state?.copy ? `Copy of ${res?.data?.Description}` : res?.data?.Description
            });
            // setGridData(mediaData.map((x, i) => ({ ...x, index: i })));
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setLoadingStatus(lang.no_record_found_error_message);
    }

    const loadCombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onParameterChange = (name, value) => {
        console.log("asdfgh","")
        setParameterDataItem(prev => ({
                ...prev, [name]: value
            }));
        setParameterDataItem({ ...parameterDataItem, [name]: value });
    }

    const isValid = () => {
        if (dataItem.Description == undefined || dataItem.Description == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false
        }

        if (Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false
        }

        return true
    }

    const onSave = async () => {
        if (isValid()) {
            const saveData = {
                ...dataItem,
                Channel: {
                    _id: dataItem.Channel._id,
                    SID: dataItem.Channel.SID,
                    FullChannelName: dataItem.Channel.FullChannelName
                },
                checkDuplicate: true,
                query: [["Channel.SID", "=", dataItem.Channel.SID], ["Name", "=", dataItem.Description], ["Archive", "=", false]]
            }

            if (loc?.state?.copy) {
                delete saveData._id;
                saveData.SID = 0;
            }

            delete saveData.index;
            console.log(saveData)
            let res = await API.saveData(ENTITYNAME.AutoPlaylistConfiguration, saveData);
            console.log(res)
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.AUTO_PLAYLIST_CONFIGURATION, data: res.data, message: res.message };
                API.SaveLogs(logData);
                utility.deleteLocalStorageItem(ENTITYNAME.AutoPlaylistConfiguration);
                onClose();
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const onAddFunction = () => {
        const isMaxDamageControl = selectedFunction.Description === "MaximumDamageControl";

        const newData = {
            title: selectedFunction.Description,
            description: selectedFunction.Description,
            parameter: isMaxDamageControl ? { maxDamageOffset: utility.convertStringTimeToMilliseconds(parameterDataItem.maxDamageOffset ?? "01:00:00") } : parameterDataItem
        };
        setDataItem({ ...dataItem, ExecutionSequence: [...dataItem.ExecutionSequence, newData] });
        setSelectedFunction({});
        setParameterDataItem({});
    }
    const onSelectionChange = useCallback(
        (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );

    const onSearch = (searchText = "") => {
        const keyword = searchText.trim().toLowerCase();
        setSearchText(searchText);

        if (!keyword) {
            // setFilterData(gridData);
            return;
        }

        const filteredData = gridData.filter((item) => {
            const title = item?.Title?.toString().toLowerCase() || "";
            const assetId = item?.AssetId?.toString().toLowerCase() || "";
            return title.includes(keyword) || assetId.includes(keyword);
        });

        // setFilterData(filteredData);
    };


    const onClose = () => {
        if (loc.state && loc.state.prevPath) {
            navigate(loc.state.prevPath)
        } else {
            navigate("/home/autoPlaylistConfiguration");
        }
    }
    const noParameterFunctions = [
        "ResetAutoFillPlaylistChildren",
        "onReturnSlotDateTimeToPlannedNominalTime",
        "saveCompleteScheduleChildrenandRefresh",
        "PlaceRatingSlideAndRatingBug",
        "MoveFirstSegmentBreakItemToLastSegment",
        "PlaceSignOffIdOnLastSegment"
    ];

    const isNoParameterFunction = selectedFunction && noParameterFunctions.includes(selectedFunction.Description);

    const removeFunctionFromGrid = (index) => {
        const updated = [...(dataItem.ExecutionSequence ?? [])];
        updated.splice(index, 1);
        setDataItem({ ...dataItem, ExecutionSequence: updated })
    };

    const MyCommandCell = (props) => (
        <div className="mt-1 ml-2" style={{ display: "flex" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeFunctionFromGrid(props.dataIndex), () => { })} />
        </div>
    )

    const parameterColumns = [
        ...new Set(
            (dataItem.ExecutionSequence || []).flatMap(item =>
                Object.keys(item.parameter || {})
            )
        )
    ];

    const DurationCell = (props) => {
    const parameterName = props.field?.replace("parameter.", "");
    const value = props.dataItem?.parameter?.[parameterName];

    return (
        <td>
            {value !== null && value !== undefined ? utility.convertMilisecondsToStringWithFrames(value) : ""}
        </td>
    );
};

    const formatParameterTitle = (key) => {
        return key.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const ParameterCell = (props) => {
    const parameterName = props.field?.replace("parameter.", "");
    const parameter = props.dataItem?.parameter;

    if (!parameter) {
        return <td></td>;
    }

    const value = parameter[parameterName];

    if (parameterName === "maxDamageOffset") { return <DurationCell {...props} />; }

    // Object value → show Description
    if (value !== null && typeof value === "object") {
        return (
            <td>
                {value.Description ?? ""}
            </td>
        );
    }

    // mediaTypeEnum → show enum Description
    if (parameterName === "mediaTypeEnum") {
        const item = Object.keys(MEDIATYPEENUM)
            .map(key => ({
                id: MEDIATYPEENUM[key],
                Description: key
            }))
            .find(item => item.id === value);

        return (
            <td>
                {item ? item.Description : value ?? ""}
            </td>
        );
    }

    // Normal string / number / boolean values
    return (
        <td>
            {value === null || value === undefined ? "" : String(value)}
        </td>
    );
};

    return (<>
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader title={SID > 0 ? lang.edit_autoplaylistconfig_editpage_header : lang.create_autoplaylistconfig_editpage_header} onSubmit={onSave} onCancel={onClose} />
                <div className="row mt-3">
                    <div className="col-md-4">
                        <label htmlFor="Description"> {lang.description_label} * </label>
                        <input type="text" className="form-control form-control-sm" name="Description" value={dataItem.Description || ""} onChange={onChange} />
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="Channel"> {lang.channel_label} * </label>
                        <DropDownList
                            style={{ backgroundColor: "white", width: "100%" }}
                            data={channel}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.Channel}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-md-4 d-flex align-items-center mt-4">
                        <input type="checkbox" name="Archive" checked={!!dataItem.Archive} onChange={onChange} />
                        <label className="ml-2 mb-0"> {lang.archive} </label>
                    </div>
                </div>

                <div className="card mt-3">
                    <div className="card-header py-2">
                        <strong>Configuration List</strong>
                    </div>
                    <div className="card-body">
                        {/* Function Selection */}
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <AddRoundButton style={{ marginTop: "0px", backgroundColor: dataItem.IsFetchFromLibrary ? "lightgray" : "" }} title={lang.add_media_episode_button_tooltip} onClick={onAddFunction} />
                            </div>
                            <div className="col-md-5">
                                <DropDownList
                                    style={{ backgroundColor: "white", width: "100%" }}
                                    data={Object.keys(AUTOFILL_SCHEDULE_CONF_FUNCS).map(f => ({ SID: AUTOFILL_SCHEDULE_CONF_FUNCS[f], Description: f, DisplayDescription: formatParameterTitle(f) }))}
                                    name="func"
                                    textField="DisplayDescription"
                                    dataItemKey="SID"
                                    value={selectedFunction}
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        setSelectedFunction(selected);
                                        setParameterDataItem({});
                                    }}
                                />
                            </div>
                            <div className="col-md-4">
                                {isNoParameterFunction && (<div className="text-muted"> No Parameter Required </div>)}
                            </div>
                        </div>

                        {selectedFunction && !isNoParameterFunction && (
                            <div className="mt-3">
                                <div className="border rounded p-3">
                                    <div className="mb-2"> <strong>Function Parameters</strong></div>

                                    {/* 3. fillUnderOverRunWithStiching */}
                                    {selectedFunction.Description === "fillUnderOverRunWithStiching" && (
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input type="checkbox" name="isKartoonChannel"
                                                        checked={parameterDataItem.isKartoonChannel}
                                                        onChange={(e) => onParameterChange("isKartoonChannel", e.target.checked)} />
                                                    <label className="ml-2 mb-0">
                                                        Kartoon Channel
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        name="isGodare"
                                                        checked={parameterDataItem.isGodare}
                                                        onChange={(e) => onParameterChange("isGodare", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0"> Godare </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        name="isSMG"
                                                        checked={parameterDataItem.isSMG}
                                                        onChange={(e) => onParameterChange("isSMG", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0"> SMG </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input type="checkbox" name="isOutdoor" checked={parameterDataItem.isOutdoor}
                                                        onChange={(e) => onParameterChange("isOutdoor", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0"> Outdoor </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input type="checkbox" name="isEcity" checked={parameterDataItem.isEcity}
                                                        onChange={(e) => onParameterChange("isEcity", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0"> Ecity </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input type="checkbox" name="isRock" checked={parameterDataItem.isRock}
                                                        onChange={(e) => onParameterChange("isRock", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Rock
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center">
                                                    <input type="checkbox" name="isStarhub" checked={parameterDataItem.isStarhub}
                                                        onChange={(e) =>
                                                            onParameterChange("isStarhub", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Starhub
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 4. ApplyBillBoards */}
                                    {selectedFunction.Description === "ApplyBillBoards" && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{lang.variation_type_label} </label>
                                                <DropDownList style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.VariationType || null}
                                                    onChange={(e) => onParameterChange("VariationType", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 5. ApplyBreakBumpers */}
                                    {selectedFunction.Description === "ApplyBreakBumpers" && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{lang.variation_type_label} </label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.VariationType || null}
                                                    onChange={(e) => onParameterChange("VariationType", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 6. ManageUnderAndOverRuns */}
                                    {selectedFunction.Description === "ManageUnderAndOverRuns" && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{lang.media_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-3 mt-2">
                                                <div className="d-flex align-items-center mt-4">
                                                    <input type="checkbox" checked={parameterDataItem.placeAllItemsInLast} onChange={(e) => onParameterChange("placeAllItemsInLast", e.target.checked)}/>
                                                    <label className="ml-2 mb-0">
                                                        Place All Items In Last
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center mt-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.pullVariations}
                                                        onChange={(e) => onParameterChange("pullVariations", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Pull Variations
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="d-flex align-items-center mt-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.checkBackToBackSameCategory}
                                                        onChange={(e) => onParameterChange("checkBackToBackSameCategory", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Check Back To Back Same Category
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 7. FillFormatSequenceInSchedule */}
                                    {selectedFunction.Description === "FillFormatSequenceInSchedule" && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{lang.variation_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.VariationType || null}
                                                    onChange={(e) => onParameterChange("VariationType", e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="d-flex align-items-center mt-3">
                                                    <input type="checkbox" checked={parameterDataItem.keepFillingIfNoSpace} onChange={(e) => onParameterChange("keepFillingIfNoSpace", e.target.checked)}/>
                                                    <label className="ml-2 mb-0">
                                                        Keep Filling If No Space
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 8. PlacingLastPositionItems */}
                                    {selectedFunction.Description === "PlacingLastPositionItems" && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>{lang.variation_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum || null}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 10. ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly */}
                                    {selectedFunction.Description === "ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly" && (
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{lang.variation_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.VariationType || null}
                                                    onChange={(e) => onParameterChange("VariationType", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label>Media Type</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum}
                                                    // value={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key })).find(
                                                    //     item => item.id === (parameterDataItem.mediaTypeEnum ?? MEDIATYPEENUM.ANY))}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="d-flex align-items-center mt-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.autoDeleteOffFooterOffset}
                                                        onChange={(e) => onParameterChange("autoDeleteOffFooterOffset", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Auto Delete Off Footer Offset
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 11. ReplaceItemsToMatchUnderAndOverRuns */}
                                    {selectedFunction.Description === "ReplaceItemsToMatchUnderAndOverRuns" && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>Variation Res</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.variationRes || null}
                                                    onChange={(e) => onParameterChange("variationRes", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label>Media Type</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum}
                                                    // value={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key })).find(
                                                    //     item => item.id === (parameterDataItem.mediaTypeEnum ?? MEDIATYPEENUM.ANY))}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <div className="d-flex align-items-center mt-4">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.autoDeleteOffFooterOffset}
                                                        onChange={(e) => onParameterChange("autoDeleteOffFooterOffset", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Auto Delete Off Footer Offset
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 12. RefillAndDeleteUnderAndOverRun */}
                                    {selectedFunction.Description === "RefillAndDeleteUnderAndOverRun" && (
                                        <div className="row">
                                            {/* variationRes */}
                                            <div className="col-md-4">
                                                <label>Variation Res</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.variationRes || null}
                                                    onChange={(e) => onParameterChange("variationRes", e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="d-flex align-items-center mt-4">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.autoDeleteOffFooterOffset}
                                                        onChange={(e) => onParameterChange("autoDeleteOffFooterOffset", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Auto Delete Off Footer Offset
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="d-flex align-items-center mt-4">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.fillInLastOnly}
                                                        onChange={(e) => onParameterChange("fillInLastOnly", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Fill In Last Only
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="d-flex align-items-center mt-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.deleteFooter}
                                                        onChange={(e) => onParameterChange("deleteFooter", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Delete Footer
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 13. FillFormatSequenceInScheduleBottomUpApproach */}
                                    {selectedFunction.Description === "FillFormatSequenceInScheduleBottomUpApproach" && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>Variation Res</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.variationRes || null}
                                                    onChange={(e) => onParameterChange("variationRes", e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="d-flex align-items-center mt-3">
                                                    <input
                                                        type="checkbox"
                                                        checked={parameterDataItem.keepFillingIfNoSpace}
                                                        onChange={(e) => onParameterChange("keepFillingIfNoSpace", e.target.checked)}
                                                    />
                                                    <label className="ml-2 mb-0">
                                                        Keep Filling If No Space
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* 17. PlacingFixedPositionItems */}
                                    {selectedFunction.Description === "PlacingFixedPositionItems" && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>{lang.media_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum || null}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 18. PlacingFirstPositionItem */}
                                    {selectedFunction.Description === "PlacingFirstPositionItem" && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>{lang.media_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum || null}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 19. MaximumDamageControl */}
                                    {selectedFunction.Description === "MaximumDamageControl" && (
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="">{lang.max_damage_offset_label}</label>
                                                <TimePickerWithFormat
                                                    className="form-control form-control-sm"
                                                    name="maxDamageOffset"
                                                    value={parameterDataItem.maxDamageOffset || "01:00:00:00"}
                                                    onChange={(e) => onParameterChange("maxDamageOffset", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* 20. PackPlaylistFor24Hours */}
                                    {selectedFunction.Description === "PackPlaylistFor24Hours" && (
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>{lang.media_type_label}</label>
                                                <DropDownList
                                                    style={{ backgroundColor: "white", width: "100%" }}
                                                    data={Object.keys(MEDIATYPEENUM).map(key => ({ id: MEDIATYPEENUM[key], Description: key }))}
                                                    textField="Description"
                                                    dataItemKey="id"
                                                    value={parameterDataItem.mediaTypeEnum || null}
                                                    onChange={(e) => onParameterChange("mediaTypeEnum", e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                    </div>
                </div>

                {/* Function Sequence */}
                <div className="card mt-3">
                    <div className="card-header py-2">
                        <strong>Function Sequence</strong>
                    </div>
                    <div className="card-body p-2">
                        <Grid
                            data={
                                dataItem.ExecutionSequence?.map((item) => ({
                                    ...item,
                                    [SELECTED_FIELD]:
                                        selectedExecutionSequenceState[
                                        idGetter(item)
                                        ],
                                }))
                            }
                            dataItemKey={DATA_ITEM_KEY}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                drag: false,
                                cell: false,
                                mode: "multiple",
                            }}
                            resizable={true}
                            className="vk-grid"
                            style={{
                                height: "65vh",
                                width: "100%"
                            }}
                        >

                            <GridNoRecords>
                                {loadingStatus}
                            </GridNoRecords>

                            <GridColumn
                                cell={MyCommandCell}
                                width="55px"
                            />

                            <GridColumn
                                field="title"
                                title={lang.title_column}
                                editable={false}
                            />

                            {/* <GridColumn
                                field="parameters"
                                title={lang.parameter_label}
                                editable={false}
                            /> */}

                            {parameterColumns.map((key) => (
                                <GridColumn
                                    key={key}
                                    field={`parameter.${key}`}
                                    title={formatParameterTitle(key)}
                                    cell={ParameterCell}
                                    editable={false}
                                />
                            ))}

                        </Grid>

                    </div>
                </div>

            </div>
        </div>

    </>)
}

export default AutoPlaylistConfiguration;